import React from 'react';
import { useOrderSaleOrderSaleStatusInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IOrderSale } from '../../order-sale-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

// Status is always disabled here: the upsert no longer sends it (new sales
// default to id = 1), and only admins can change it via the separate
// "Cambiar status" dialog / updateOrderSaleStatus mutation.
export function OrderSaleStatusInput() {
    const inputName: keyof IOrderSale = 'order_sale_status_id';
    const { data } = useOrderSaleOrderSaleStatusInputQuery();

    const orderSaleStatuses = data?.getOrderSaleStatuses || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.order_sale_status_id)}
            options={orderSaleStatuses}
            disabled
        />
    );
}
